import { FormSelect, ToggableButton } from '@UI/index';
import { Modal } from '@kathondvla/react-shared-components/src/components';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Button, CircularProgress } from '@mui/material';
import { selectDuplicateActivityModalStartDates } from '@store/calendar/calendarSelectors';
import {
  confirmDuplicateActivity,
  duplicateActivityModalClose,
} from '@store/calendar/calendarState';
import { requiredValidation } from '@utils/validations';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';

import iconCopyWhite from '@assets/img/icon_copy_white.svg';

import './modals.scss';

const DuplicateActivityModal = () => {
  const dispatch = useDispatch();
  const startDates = useSelector(selectDuplicateActivityModalStartDates);
  const isSaving = useSelector(
    (state) => state.calendar.duplicateActivityModal.status === 'SAVING',
  );
  const duplicateData = useSelector((state) => state.calendar.duplicateActivityModal.data);
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [classes, setClasses] = useState(
    duplicateData?.classes.map((c) => ({ ...c, selected: false })) ?? [],
  );
  const { control, handleSubmit } = useForm();

  const noClasses = classes.filter((c) => c.selected).length === 0;

  const toggleClassHandler = (cls) => {
    setClasses((prev) =>
      prev.map((c) => (c.href === cls.href ? { ...c, selected: !c.selected } : c)),
    );
  };

  const onCloseHandler = () => {
    dispatch(duplicateActivityModalClose());
  };

  const onConfirmHandler = () => {
    if (!selectedStartDate || isSaving || !duplicateData || noClasses) return;
    const selectedClasses = classes.filter((c) => c.selected);
    dispatch(
      confirmDuplicateActivity({
        ...duplicateData,
        classes: selectedClasses,
        startDate: selectedStartDate,
      }),
    );
  };

  return (
    <>
      <Modal.Header title="Activiteit dupliceren" icon={iconCopyWhite} onClose={onCloseHandler} />

      <Modal.Body>
        <div className="duplicate-activity-modal">
          <div className="period-field">
            <span className="label">Periode*</span>
            <div className="period-selector">
              <FormSelect
                name="startDate"
                value={selectedStartDate}
                options={startDates}
                control={control}
                placeholder="Kies een startweek"
                onChange={(value) => setSelectedStartDate(value)}
                validations={{
                  required: (value) => requiredValidation(value),
                }}
              />
            </div>
          </div>
          <div className="classes">
            <span className="label">Klassen*</span>
            <div className="classes-buttons">
              {classes.map((cls) => (
                <ToggableButton
                  key={cls.href}
                  isActive={cls.selected}
                  activeColor={cls.color.background}
                  onClick={() => toggleClassHandler(cls)}
                >
                  {cls.$$displayName}
                </ToggableButton>
              ))}
            </div>
            {noClasses && <span className="error-msg">Je moet min 1 klas selecteren</span>}
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="outlined" onClick={onCloseHandler}>
          Annuleren
        </Button>
        <Button
          variant="contained"
          disabled={!selectedStartDate || noClasses}
          onClick={handleSubmit(onConfirmHandler)}
          startIcon={
            isSaving ? (
              <CircularProgress
                size={20}
                sx={{ m: 'auto', display: 'block', color: 'primary.contrastText' }}
              />
            ) : (
              <ContentCopyIcon />
            )
          }
        >
          <span>Activiteit dupliceren</span>
        </Button>
      </Modal.Footer>
    </>
  );
};

export default DuplicateActivityModal;
